import { useEffect, useState } from "react";

// Phone width: below Tailwind's `sm` breakpoint (640px). Lists switch from
// tables to cards there, so nothing has to be scrolled sideways.
const QUERY = "(max-width: 639px)";
const matches = () => typeof window !== "undefined" && !!window.matchMedia?.(QUERY).matches;

export default function useIsPhone() {
  const [phone, setPhone] = useState(matches);
  useEffect(() => {
    const media = window.matchMedia?.(QUERY);
    if (!media) return undefined;
    const update = () => setPhone(media.matches);
    update();
    media.addEventListener?.("change", update);
    return () => media.removeEventListener?.("change", update);
  }, []);
  return phone;
}
